import React, { useEffect } from "react";
import "./App.css";
import AppRoutes from "./routes/AppRoutes";
import { BrowserRouter } from "react-router-dom";
import { useAutoLogout } from "./hooks/useAutoLogout";
import AutoLogoutAlert from "./components/AutoLogoutAlert/AutoLogoutAlert";
import { useWfSocket } from "./hooks/wf/useSocket";
import { useSocket } from "./hooks/ats/useSocket";
import { getSafeDeviceInfo } from "./utils/deviceUtils";
import { initMixpanel } from "./utils/mixpanelService";

const App = () => {
  const { showWarning, handleWarningClose } = useAutoLogout();
  useWfSocket("workforce");
  useSocket("ats");
  initMixpanel();
  
  return (
    <div className="h-full">
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
      <AutoLogoutAlert isOpen={showWarning} onClose={handleWarningClose} />
      {/* <AutoLogoutAlert isOpen={showWarning} onClose={handleWarningClose} /> */}
    </div>
  );
};

export default App;

// import React from "react";
// import "./App.css";
// import AppRoutes from "./routes/AppRoutes";
// import { BrowserRouter } from "react-router-dom";
// import { useAutoLogout } from "./hooks/useAutoLogout";
// import AutoLogoutAlert from "./components/AutoLogoutAlert/AutoLogoutAlert";
// function App() {
//   const { showWarning, handleWarningClose } = useAutoLogout();
//   return (
//     <div className="h-screen">
//       <BrowserRouter>
//         <AppRoutes />
//       </BrowserRouter>
//       <AutoLogoutAlert isOpen={showWarning} onClose={handleWarningClose} />
//       {/* <AutoLogoutAlert isOpen={showWarning} onClose={handleWarningClose} /> */}
//     </div>
//   );
// }

// export default App;
